import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ExtractService } from '../../shared/services/extract/extract.service';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';
import { HeaderService } from '../services/header.service';

export function hasValidAuthToken(
  token: string | null | undefined,
  decodeToken: (value: string) => unknown,
): boolean {
  if (!token) {
    return false;
  }

  return decodeToken(token) != null;
}

export function canActivateWithAuth(options: {
  allowDevAuthBypass: boolean;
  token: string | null | undefined;
  decodeToken: (value: string) => unknown;
}): boolean {
  if (options.allowDevAuthBypass) {
    return true;
  }

  return hasValidAuthToken(options.token, options.decodeToken);
}

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  const extractService = inject(ExtractService);
  const headerService = inject(HeaderService);

  const tokenUrl = route.queryParamMap.get('Token');

  if(tokenUrl) {
    try {
      //Mesma validação do TokenVerify
      const tokenValidado = await extractService.getDecodedAccessToken(tokenUrl);

      if(!tokenValidado){
        return router.createUrlTree(['/token-invalido']);
      }

      //salva token no storage
      localStorageService.add('sToken', tokenUrl);

      // O portal envia "True"/"False" e as rotas internas "true"/"false";
      // setVisible normaliza o valor no storage e atualiza o header da sessão atual.
      const mostrarHeader = route.queryParamMap.get('MostrarHeader');

      if (mostrarHeader != null) {
        headerService.setVisible(mostrarHeader.toLowerCase() === 'true');
      }

      return true;
    } catch (error) {
      console.error('Erro ao validar token:', error);
      return router.createUrlTree(['/token-invalido']);
    }
  }

  if (environment.allowDevAuthBypass) {
    return true;
  }

  if (
    hasValidAuthToken(localStorageService.get('sToken'), (token) =>
      extractService.getDecodedAccessToken(token),
    )
  ) {
    return true;
  }

  return inject(Router).createUrlTree(['/token-invalido']);
};
